import { render } from "./info-form.vue?vue&type=template&id=45497468"
import script from "./info-form.vue?vue&type=script&lang=js"
export * from "./info-form.vue?vue&type=script&lang=js"

import "./info-form.vue?vue&type=style&index=0&id=45497468&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__